import { setU16be, slice, u16be, u24be, u8 } from "./bytes.js";
import { BOX_STRUCT_LENGTH, MON, PARTY_STRUCT_LENGTH } from "./layout.js";
import type { MonBox, MonParty, Stats } from "./types.js";

function stats5(b: Uint8Array, off: number): Stats {
  return {
    hp: u16be(b, off),
    atk: u16be(b, off + 2),
    def: u16be(b, off + 4),
    spd: u16be(b, off + 6),
    spc: u16be(b, off + 8),
  };
}

/** Decodes a 33-byte box struct (or the first 33 bytes of a party struct). */
export function decodeBoxStruct(src: Uint8Array): MonBox {
  if (src.length < BOX_STRUCT_LENGTH) throw new RangeError(`box struct needs ${BOX_STRUCT_LENGTH} bytes`);
  const raw = src.slice(0, BOX_STRUCT_LENGTH);
  return {
    species: u8(raw, MON.species),
    hp: u16be(raw, MON.hp),
    level: u8(raw, MON.boxLevel),
    status: u8(raw, MON.status),
    type1: u8(raw, MON.type1),
    type2: u8(raw, MON.type2),
    catchRate: u8(raw, MON.catchRate),
    moves: [u8(raw, MON.moves), u8(raw, MON.moves + 1), u8(raw, MON.moves + 2), u8(raw, MON.moves + 3)],
    otId: u16be(raw, MON.otId),
    exp: u24be(raw, MON.exp),
    statExp: stats5(raw, MON.statExp),
    dvBytes: [u8(raw, MON.dvs), u8(raw, MON.dvs + 1)],
    pp: [u8(raw, MON.pp), u8(raw, MON.pp + 1), u8(raw, MON.pp + 2), u8(raw, MON.pp + 3)],
    raw,
  };
}

export function decodePartyStruct(src: Uint8Array): MonParty {
  if (src.length < PARTY_STRUCT_LENGTH) throw new RangeError(`party struct needs ${PARTY_STRUCT_LENGTH} bytes`);
  const raw44 = src.slice(0, PARTY_STRUCT_LENGTH);
  return {
    ...decodeBoxStruct(raw44),
    partyLevel: u8(raw44, MON.level),
    stats: stats5(raw44, MON.stats),
    raw44,
  };
}

/** Builds a 44-byte party struct from a box struct plus level and computed stats. */
export function buildPartyStruct(box: Uint8Array, level: number, stats: Stats): Uint8Array {
  const out = new Uint8Array(PARTY_STRUCT_LENGTH);
  out.set(slice(box, 0, BOX_STRUCT_LENGTH), 0);
  out[MON.boxLevel] = level;
  out[MON.level] = level;
  setU16be(out, MON.stats, stats.hp);
  setU16be(out, MON.stats + 2, stats.atk);
  setU16be(out, MON.stats + 4, stats.def);
  setU16be(out, MON.stats + 6, stats.spd);
  setU16be(out, MON.stats + 8, stats.spc);
  if (u16be(out, MON.hp) > stats.hp) setU16be(out, MON.hp, stats.hp);
  return out;
}
